import {
	MapboxMarkerPopup,
	MapboxMarkerRoot,
	MapboxMarkerTrigger,
	MapboxRoot,
} from "@/components/ui/Mapbox";
import { Skeleton } from "@/components/ui/Skeleton";
import { env } from "@/env.mjs";
import type { BlokRetailer } from "@/storyblok";
import { Suspense } from "react";
import { Retailer } from "../../Retailer";
import styles from "./RetailersMap.module.css";

export interface RetailersMapProps {
	retailers: BlokRetailer[];
	ref: React.MutableRefObject<mapboxgl.Map | null>;
	mapZoom: number;
	mapCenter: [number, number];
}

export const RetailersMap = ({
	retailers,
	ref,
	mapZoom,
	mapCenter,
}: RetailersMapProps) => {
	const styleUrl = env.NEXT_PUBLIC_MAPBOX_STYLE_URL;
	const accesToken = env.NEXT_PUBLIC_MAPBOX_ACCESS_TOKEN;

	return (
		<Suspense fallback={<RetailersMapSkeleton />}>
			<MapboxRoot
				zoom={mapZoom}
				center={mapCenter}
				mapRef={ref}
				accessToken={accesToken}
				styleUrl={styleUrl}
				className={styles.map}
			>
				{retailers.map((retailer, i) => (
					<MapboxMarkerRoot
						key={i}
						coordinates={[
							Number(retailer.longitude),
							Number(retailer.latitude),
						]}
					>
						<MapboxMarkerTrigger name={retailer.name}>
							<div className={styles.marker} />
						</MapboxMarkerTrigger>
						<MapboxMarkerPopup name={retailer.name}>
							<Retailer
								name={retailer.name}
								street={retailer.street}
								city={retailer.city}
								country={retailer.country}
								postalCode={retailer.postalCode}
								website={retailer.website}
								phone={retailer.phone}
								coordinates={[
									Number(retailer.latitude),
									Number(retailer.longitude),
								]}
								variant="popup"
							/>
						</MapboxMarkerPopup>
					</MapboxMarkerRoot>
				))}
			</MapboxRoot>
		</Suspense>
	);
};

export const RetailersMapSkeleton = () => {
	return <Skeleton className={styles.map} />;
};
